// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CompaniesList } from '../models';
import { Company } from '../models';
import { CompanyDocumentInfo } from '../models';
import { CompanyDocumentInfoEdit } from '../models';
import { CompanyForm } from '../models';
import { EmployeesList } from '../models';
import { ErrorResponse } from '../models';
import { UserCsvImportList } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root`
         * @summary Delete company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling _delete.');
            }
            const localVarPath = `/v1/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Add user to company employee.
         * @param {string} id 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployee(id: string, user_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addEmployee.');
            }
            // verify required parameter 'user_id' is not null or undefined
            if (user_id === null || user_id === undefined) {
                throw new RequiredError('user_id','Required parameter user_id was null or undefined when calling addEmployee.');
            }
            const localVarPath = `/v1/company/{id}/employee/deprecated/{user_id}/add`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root`
         * @summary Create new company.
         * @param {CompanyForm} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: CompanyForm, options: any = {}): RequestArgs {
            const localVarPath = `/v1/company/create`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root`
         * @summary Disable company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling disable.');
            }
            const localVarPath = `/v1/company/{id}/disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit information about company.
         * @param {string} id 
         * @param {CompanyForm} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: CompanyForm, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit CompanyDocumentInfo.
         * @param {string} id 
         * @param {CompanyDocumentInfoEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDocumentInfo(id: string, body?: CompanyDocumentInfoEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling editDocumentInfo.');
            }
            const localVarPath = `/v1/company/{id}/document-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root`
         * @summary Enable company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling enable.');
            }
            const localVarPath = `/v1/company/{id}/enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `company.enabled`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get information about company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/company/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get CompanyDocumentInfo.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentInfo(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getDocumentInfo.');
            }
            const localVarPath = `/v1/company/{id}/document-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Upload users from csv.
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} [delimiter] 
         * @param {string} [enclosure] 
         * @param {string} [escape] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUser(id: string, fileId: string, delimiter?: string, enclosure?: string, escape?: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling importUser.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling importUser.');
            }
            const localVarPath = `/v1/company/{id}/file/{fileId}/users/import`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


            if (delimiter !== undefined) { 
                localVarFormParams.append('delimiter', delimiter as any);
            }
    
            if (enclosure !== undefined) { 
                localVarFormParams.append('enclosure', enclosure as any);
            }
    
            if (escape !== undefined) { 
                localVarFormParams.append('escape', escape as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Find companies by criteria.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {Array<string>} [ownerIds] 
         * @param {Array<string>} [employeesIds] Ids of users, who are employees of the company
         * @param {boolean} [enabled] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, title?: string, ownerIds?: Array<string>, employeesIds?: Array<string>, enabled?: boolean, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/v1/company/list`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (ownerIds) {
                localVarQueryParameter['ownerIds'] = ownerIds.join(COLLECTION_FORMATS.csv);
            }

            if (employeesIds) {
                localVarQueryParameter['employeesIds'] = employeesIds.join(COLLECTION_FORMATS.csv);
            }

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company employees list.
         * @param {string} id 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployees(id: string, offset?: number, limit?: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling listEmployees.');
            }
            const localVarPath = `/v1/company/{id}/employee/deprecated/list`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of my companies.
         * @param {'owner' | 'employee'} type 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(type: 'owner' | 'employee', offset?: number, limit?: number, options: any = {}): RequestArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling my.');
            }
            const localVarPath = `/v1/company/my`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete company employee.
         * @param {string} id 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmployee(id: string, user_id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeEmployee.');
            }
            // verify required parameter 'user_id' is not null or undefined
            if (user_id === null || user_id === undefined) {
                throw new RequiredError('user_id','Required parameter user_id was null or undefined when calling removeEmployee.');
            }
            const localVarPath = `/v1/company/{id}/employee/deprecated/{user_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(user_id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root`
         * @summary Delete company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration)._delete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Add user to company employee.
         * @param {string} id 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployee(id: string, user_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).addEmployee(id, user_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root`
         * @summary Create new company.
         * @param {CompanyForm} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: CompanyForm, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).create(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root`
         * @summary Disable company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).disable(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit information about company.
         * @param {string} id 
         * @param {CompanyForm} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: CompanyForm, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit CompanyDocumentInfo.
         * @param {string} id 
         * @param {CompanyDocumentInfoEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDocumentInfo(id: string, body?: CompanyDocumentInfoEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDocumentInfo> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).editDocumentInfo(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root`
         * @summary Enable company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).enable(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `company.enabled`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get information about company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).get(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get CompanyDocumentInfo.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentInfo(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyDocumentInfo> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).getDocumentInfo(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Upload users from csv.
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} [delimiter] 
         * @param {string} [enclosure] 
         * @param {string} [escape] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUser(id: string, fileId: string, delimiter?: string, enclosure?: string, escape?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserCsvImportList> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).importUser(id, fileId, delimiter, enclosure, escape, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Find companies by criteria.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {Array<string>} [ownerIds] 
         * @param {Array<string>} [employeesIds] Ids of users, who are employees of the company
         * @param {boolean} [enabled] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, title?: string, ownerIds?: Array<string>, employeesIds?: Array<string>, enabled?: boolean, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesList> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).list(ids, title, ownerIds, employeesIds, enabled, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get company employees list.
         * @param {string} id 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployees(id: string, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeesList> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).listEmployees(id, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get list of my companies.
         * @param {'owner' | 'employee'} type 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(type: 'owner' | 'employee', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesList> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).my(type, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete company employee.
         * @param {string} id 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmployee(id: string, user_id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = CompanyApiAxiosParamCreator(configuration).removeEmployee(id, user_id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root`
         * @summary Delete company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: string, options?: any) {
            return CompanyApiFp(configuration)._delete(id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Add user to company employee.
         * @param {string} id 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEmployee(id: string, user_id: string, options?: any) {
            return CompanyApiFp(configuration).addEmployee(id, user_id, options)(axios, basePath);
        },
        /**
         * **Security:** `root`
         * @summary Create new company.
         * @param {CompanyForm} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: CompanyForm, options?: any) {
            return CompanyApiFp(configuration).create(body, options)(axios, basePath);
        },
        /**
         * **Security:** `root`
         * @summary Disable company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable(id: string, options?: any) {
            return CompanyApiFp(configuration).disable(id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit information about company.
         * @param {string} id 
         * @param {CompanyForm} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: CompanyForm, options?: any) {
            return CompanyApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Edit CompanyDocumentInfo.
         * @param {string} id 
         * @param {CompanyDocumentInfoEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDocumentInfo(id: string, body?: CompanyDocumentInfoEdit, options?: any) {
            return CompanyApiFp(configuration).editDocumentInfo(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root`
         * @summary Enable company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable(id: string, options?: any) {
            return CompanyApiFp(configuration).enable(id, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `company.enabled`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get information about company.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any) {
            return CompanyApiFp(configuration).get(id, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get CompanyDocumentInfo.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentInfo(id: string, options?: any) {
            return CompanyApiFp(configuration).getDocumentInfo(id, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Upload users from csv.
         * @param {string} id 
         * @param {string} fileId 
         * @param {string} [delimiter] 
         * @param {string} [enclosure] 
         * @param {string} [escape] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importUser(id: string, fileId: string, delimiter?: string, enclosure?: string, escape?: string, options?: any) {
            return CompanyApiFp(configuration).importUser(id, fileId, delimiter, enclosure, escape, options)(axios, basePath);
        },
        /**
         * 
         * @summary Find companies by criteria.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {Array<string>} [ownerIds] 
         * @param {Array<string>} [employeesIds] Ids of users, who are employees of the company
         * @param {boolean} [enabled] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, title?: string, ownerIds?: Array<string>, employeesIds?: Array<string>, enabled?: boolean, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title', order?: 'ASC' | 'DESC', options?: any) {
            return CompanyApiFp(configuration).list(ids, title, ownerIds, employeesIds, enabled, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get company employees list.
         * @param {string} id 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEmployees(id: string, offset?: number, limit?: number, options?: any) {
            return CompanyApiFp(configuration).listEmployees(id, offset, limit, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get list of my companies.
         * @param {'owner' | 'employee'} type 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(type: 'owner' | 'employee', offset?: number, limit?: number, options?: any) {
            return CompanyApiFp(configuration).my(type, offset, limit, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Delete company employee.
         * @param {string} id 
         * @param {string} user_id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEmployee(id: string, user_id: string, options?: any) {
            return CompanyApiFp(configuration).removeEmployee(id, user_id, options)(axios, basePath);
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * **Security:** `root`
     * @summary Delete company.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public _delete(id: string, options?: any) {
        return CompanyApiFp(this.configuration)._delete(id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Add user to company employee.
     * @param {string} id 
     * @param {string} user_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public addEmployee(id: string, user_id: string, options?: any) {
        return CompanyApiFp(this.configuration).addEmployee(id, user_id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root`
     * @summary Create new company.
     * @param {CompanyForm} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public create(body?: CompanyForm, options?: any) {
        return CompanyApiFp(this.configuration).create(body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root`
     * @summary Disable company.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public disable(id: string, options?: any) {
        return CompanyApiFp(this.configuration).disable(id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Edit information about company.
     * @param {string} id 
     * @param {CompanyForm} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public edit(id: string, body?: CompanyForm, options?: any) {
        return CompanyApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Edit CompanyDocumentInfo.
     * @param {string} id 
     * @param {CompanyDocumentInfoEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public editDocumentInfo(id: string, body?: CompanyDocumentInfoEdit, options?: any) {
        return CompanyApiFp(this.configuration).editDocumentInfo(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root`
     * @summary Enable company.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public enable(id: string, options?: any) {
        return CompanyApiFp(this.configuration).enable(id, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `company.enabled`  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get information about company.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public get(id: string, options?: any) {
        return CompanyApiFp(this.configuration).get(id, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get CompanyDocumentInfo.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public getDocumentInfo(id: string, options?: any) {
        return CompanyApiFp(this.configuration).getDocumentInfo(id, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Upload users from csv.
     * @param {string} id 
     * @param {string} fileId 
     * @param {string} [delimiter] 
     * @param {string} [enclosure] 
     * @param {string} [escape] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public importUser(id: string, fileId: string, delimiter?: string, enclosure?: string, escape?: string, options?: any) {
        return CompanyApiFp(this.configuration).importUser(id, fileId, delimiter, enclosure, escape, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Find companies by criteria.
     * @param {Array<string>} [ids] 
     * @param {string} [title] 
     * @param {Array<string>} [ownerIds] 
     * @param {Array<string>} [employeesIds] Ids of users, who are employees of the company
     * @param {boolean} [enabled] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'title'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public list(ids?: Array<string>, title?: string, ownerIds?: Array<string>, employeesIds?: Array<string>, enabled?: boolean, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, offset?: number, limit?: number, sort?: 'title', order?: 'ASC' | 'DESC', options?: any) {
        return CompanyApiFp(this.configuration).list(ids, title, ownerIds, employeesIds, enabled, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get company employees list.
     * @param {string} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public listEmployees(id: string, offset?: number, limit?: number, options?: any) {
        return CompanyApiFp(this.configuration).listEmployees(id, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get list of my companies.
     * @param {'owner' | 'employee'} type 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public my(type: 'owner' | 'employee', offset?: number, limit?: number, options?: any) {
        return CompanyApiFp(this.configuration).my(type, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or (`company.owner` and `company.enabled`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Delete company employee.
     * @param {string} id 
     * @param {string} user_id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public removeEmployee(id: string, user_id: string, options?: any) {
        return CompanyApiFp(this.configuration).removeEmployee(id, user_id, options)(this.axios, this.basePath);
    }

}
